module.exports = __webpack_public_path__ + "static/media/greenParrot.9e8a445d.png";